// Doc: siehe https://docs.moodle.org/311/en/Moodle_XML_format
function get_head(category) {
  var lines = [];
  var s = `<?xml version="1.0" encoding="UTF-8"?>
      <quiz>
          <!-- question: 0  -->
          <question type="category">
          <category>
            <text>$course$/top/$$CATEGORY</text>
          </category>
          <info format="moodle_auto_format">
            <text>G24 default text</text>
          </info>
          <idnumber></idnumber>
        </question>`;

  return s.replace("$$CATEGORY", category);
}

function get_multichoice_xml(question) {
  var lines = [];

  // Create the header for the question
  var head = `<question type="multichoice">
        <name>
          <text>$$TITLE</text>
        </name>
        <questiontext format="html">
          <text><![CDATA[<p dir="ltr" style="text-align: left;">$$TEXT</p>]]></text>
        </questiontext>
        <generalfeedback format="html">
          <text></text>
        </generalfeedback>
        <defaultgrade>$$MAX</defaultgrade>
        <penalty>0.3333333</penalty>
        <hidden>0</hidden>
        <idnumber></idnumber>
        <single>false</single>
        <shuffleanswers>true</shuffleanswers>
        <answernumbering>$$ANSWERNUMBERING</answernumbering>
        <showstandardinstruction>0</showstandardinstruction>
        <correctfeedback format="html">
          <text>Die Antwort ist korrekt.</text>
        </correctfeedback>
        <partiallycorrectfeedback format="html">
          <text>Die Antwort ist teilweise richtig.</text>
        </partiallycorrectfeedback>
        <incorrectfeedback format="html">
          <text>Die Antwort ist falsch.</text>
        </incorrectfeedback>
        <shownumcorrect/>
        `;

  head = head.replace("$$TITLE", question.title);
  head = head.replace("$$TEXT", question.text);
  head = head.replace("$$MAX", question.P);
  head = head.replace("$$ANSWERNUMBERING", question.moodle_answernumbering);
  

  lines.push(head);

  // Now add all answer options (choices)--------------------------------------
  var choice_xml_template = `
    <answer fraction="$$CHOICE_FRACTION" format="html">
    <text><![CDATA[<p dir="ltr" style="text-align: left;">$$CHOICE_TEXT</p>]]></text>
    <feedback format="html">
      <text></text>
    </feedback>
  </answer>
    `;

  var choice_xml;
  var nr_correct = question.correct.length;
  var nr_false = question.choices.length - nr_correct;
  var fraction;

  question.choices.forEach((choice) => {
    fraction = question.correct.includes(choice.label)
      ? 100 / nr_correct
      : -100 / nr_false;

    choice_xml = choice_xml_template
      .replace("$$CHOICE_TEXT", choice.text)
      .replace("$$CHOICE_FEEDBACK", "<missing>")
      .replace("$$CHOICE_FRACTION", fraction);

    lines.push(choice_xml);
  });

  if (question.moodle_tags.length > 0) {
    var tagLine = "<tag><text>$$TAG</text></tag>";
    var tags = [];

    lines.push("<tags>");
    question.moodle_tags.forEach((tag) => {
      lines.push(tagLine.replace("$$TAG", tag));
    });

    lines.push("</tags>");
  }

  // Now close the text...
  lines.push("</question>");

  return lines;
}

// Braucht nur einen Test
export function create_moodle_xml(test) {
  var lines = [];

  // Get the xml code for the header
  lines.push(get_head(test.moodle_category));

  // Get the xml code for each question
  test.questions.forEach((question) => {
    get_multichoice_xml(question).forEach((zeile) => {
      lines.push(zeile);
    });
  });

  lines.push("</quiz>");

  return lines;
}
